import React from 'react';

const fmt = (value) =>
  Number.isFinite(value) ? value.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '-';

export default function CoordinateInspector({ inspection }) {
  return (
    <section className="gis-panel coordinate-panel">
      <h2>Coordinate Transformation Demo</h2>
      {inspection ? (
        <>
          <p className="hint-text">Click anywhere on the globe to inspect transformed coordinates.</p>
          <div className="coordinate-row">
            <span>WGS84</span>
            <span>
              {fmt(inspection.wgs84.lat)}°, {fmt(inspection.wgs84.lng)}°
            </span>
          </div>
          <div className="coordinate-row">
            <span>SWEREF 99 TM</span>
            <span>
              E {fmt(inspection.sweref99tm.easting)} / N {fmt(inspection.sweref99tm.northing)}
            </span>
          </div>
          <div className="coordinate-row">
            <span>UTM Zone 33N</span>
            <span>
              E {fmt(inspection.utm33n.easting)} / N {fmt(inspection.utm33n.northing)}
            </span>
          </div>
          <div className="coordinate-row">
            <span>Web Mercator</span>
            <span>
              X {fmt(inspection.mercator.x)} / Y {fmt(inspection.mercator.y)}
            </span>
          </div>
        </>
      ) : (
        <p className="hint-text">Click the globe to generate coordinate transformations.</p>
      )}
    </section>
  );
}
